import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const images = pageImages['closed-end-manual-tie-balers'];


const manualTieModelHeaders = ['Series', '3030', '3430', '3442', '5030', '5042', '6042', '6046', '7842', '7846'];

const manualTieModelRows = [
  ['Hopper/Feed Opening (LxW)', '30 X 30', '34 X 30', '34 X 42', '50 X 30', '34 X 42', '60 X 42', '60 X 46', '78 X 42', '78 X 46'],
  ['Strokes Per Minute', '2 to 4', '2 to 5', '2 to 5', '2 to 5', '2 to 5', '2 to 5', '2 to 5', '2 to 5', '2 to 5'],
  ['Cylinder Bore', '6, 7 or 8', '6, 7 or 8', '6, 7 or 8', '7 or 8', '7 or 8', '7, 8 or 10', '7, 8 or 10', '8 or 10', '8 or 10'],
  ['Power Unit HP', '20 to 40', '30 to 50', '30 to 50', '30 to 50', '30 to 50', '30 to 60', '30 to 60', '30 to 60', '30 to 60'],
];

function ClosedEndManualTieBalers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link className="active" to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Closed-End Manual Tie Balers</h2>
          <div className="body-copy page-summary-copy"><strong>Horizontal closed-end semi-automatic balers</strong> with vertical in-feed chutes, 30 inch wide or extra wide-mouth 42 inch or 46 inch hoppers, 3-1/2 sided hoppers, <strong>cart dumping systems</strong>, pre-press chambers, and many other features and options for baling all types of materials and wastes. Medium-duty and extra heavy-duty models are configured for various industrial and commercial applications.</div>
          <div className="page-summary-notes">
              <span>30 inch, 42 inch, and 46 inch hopper options</span>
              <span>Manual tie wire or strap operation</span>
              <span>Industrial and commercial applications</span>
          </div>
          <PagePhotoViewer title="Closed-End Manual Tie Balers" images={images} showLeadCopy={false} layout="stacked" />
          <div className="content-stack">
            
            <section className="content-block">
              <h3>Standard Single Ram Manual Tie Baler Models</h3>
              <div className="body-copy">The original C+M model guide compares common <strong>hopper openings</strong>, ram speeds, <strong>cylinder bore options</strong>, and hydraulic power ranges for standard single ram manual tie models.</div>
              <div className="spec-table-block">
                <table className="spec-table">
                  <thead>
                    <tr>{manualTieModelHeaders.map((header) => <th key={header}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {manualTieModelRows.map((row) => (
                      <tr key={row[0]}>{row.map((cell, cellIndex) => <td key={`${row[0]}-${cellIndex}`}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default ClosedEndManualTieBalers;
